export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.idatelier.in/api';
export const BASE_URL = API_BASE_URL.replace(/\/api$/, '');

export const apiCall = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  const url = (
    endpoint.startsWith('/authentication/') ||
    endpoint.startsWith('/inventory/') ||
    endpoint.startsWith('/designers/') ||
    endpoint.startsWith('/service/')
  )
    ? `${BASE_URL}${endpoint}`
    : `${API_BASE_URL}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    headers,
  });

  let data;
  try {
    data = await response.json();
  } catch (error) {
    if (!response.ok) {
      throw new Error('An error occurred while fetching data.');
    }
    return null;
  }

  if (!response.ok) {
    throw new Error(data.message || data.error || 'API Error');
  }

  return data;
};

export const apiUpload = async (endpoint, formData, options = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  const url = (
    endpoint.startsWith('/authentication/') ||
    endpoint.startsWith('/inventory/') ||
    endpoint.startsWith('/designers/') ||
    endpoint.startsWith('/service/')
  )
    ? `${BASE_URL}${endpoint}`
    : `${API_BASE_URL}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    method: 'POST',
    body: formData,
    headers,
  });

  let data;
  try {
    data = await response.json();
  } catch (error) {
    if (!response.ok) {
      throw new Error('An error occurred while uploading.');
    }
    return null;
  }

  if (!response.ok) {
    throw new Error(data.message || data.error || 'API Error');
  }

  return data;
};
